import { auto } from '@popperjs/core';
import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Pagination, Navigation]);

function initMobileSlider(parent, wrapper, items, breakpoint = 768) {
  if (true) {
    const $parent = document.querySelector(parent);
    if (!$parent) {
      return
    }
    const $wrapper = $parent.querySelector(wrapper);
    const $items = $wrapper.querySelectorAll(items);

    $parent.classList.add('swiper');
    $wrapper.classList.add('swiper-wrapper');
    $wrapper.classList.remove(wrapper.replace('.', ''));
    $items.forEach((slide) => slide.classList.add('swiper-slide'));

    const swiper1 = new Swiper(parent, {
      slidesPerView: 'auto',

      spaceBetween:
        parent == '.section7__swiper'
          ? 14
          : parent === '.section7__slider'
          ? 80
          : 22,
      // breakpoints: {
      //   1024: {
      //     slidesPerView: parent == '.swiper-1' ? 'auto' : '3.5',
      //     spaceBetween: 24,
      //   },
      //   476: {
      //     slidesPerView: parent == '.swiper-1' ? 'auto' : 'auto',
      //     spaceBetween: 24,
      //   },
      // },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

initMobileSlider(
  '.section3__swiper',
  '.section3__swiper-wrapper',
  '.section3__swiper-slide'
);
initMobileSlider(
  '.section8__content-left-swiper',
  '.section8__content-left-wrapper',
  '.section8__content-left-item'
);
initMobileSlider(
  '.section7__swiper',
  '.section7__swiper-wrapper',
  '.section7__swiper-item'
);
initMobileSlider(
  '.section7__slider',
  '.section7__slider-wrapper',
  '.section7__slider-el'
);
